import http from "../http-common";

class ArenaDataService {
  getAll() {
    return http.get("/arenas");
  }
  
  get(id) {
    return http.get(`/arena/${id}`);
  }
  
  getPlace(arenaId, placeName) {
    return http.get(`/place/${arenaId}?placeName=${placeName}`);
  }
  
  getReplays(arenaId, placeName, date, hour) {
    return http.get(`/replays?arenaId=${arenaId}&placeName=${placeName}&date=${date}&hour=${hour}`);
  }
}

export default new ArenaDataService();